import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Auth lives in an httpOnly mm_token cookie — we just ask the server who we are.
  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setUser(r.data.user);
    return r.data.user;
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // `credential` is the ID-token JWT returned by Google Identity Services on the frontend.
  // Backend verifies it, find-or-creates the user, sets the mm_token cookie.
  const handleGoogleCredential = async (credential) => {
    const r = await api.post("/auth/google", { credential });
    setUser(r.data.user);
    return r.data; // {token, user, is_new}
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* clearing local state is what matters */ }
    setUser(null);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, handleGoogleCredential }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
